export const PLAYBACK_PAGE_MAX_TIME_RANGE_DEFAULT_INTERVAL: number = 60; //MINUTES
export const STATIC_ANALYSIS_PAGE_MAX_TIME_RANGE_DEFAULT_INTERVAL: number = 10; //MINUTES
